import { inject } from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import { AuthenticationService } from './authentication.service';

export const authLoadGuard = (route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  if (authService.isCurrentlyLoggedIn()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
